import {createSvgIcon} from '../create-svg-icon';

export const SquareIcon = createSvgIcon(
  <path d="M3 3v18h18V3H3zm16 16H5V5h14v14z" />
, 'SquareOutlined');
